/* ==========================================================================
   POESPAS — Gratis beanie bij een Coat Jenny            (Claude, 07-09-2026)

   WAT DOET DIT
   Legt iemand een jas in de winkelmand, dan verschijnt een keuzescherm met de
   drie beanie-kleuren. De gekozen beanie gaat als losse regel de mand in, met
   de verborgen eigenschap _cadeau_bij_jas. Gaat de jas er weer uit, dan haalt
   dit script de bijbehorende cadeau-regel er ook uit.

   DE PRIJS VAN €0 KOMT HIER NIET VANDAAN.
   Die regelt Shopify met een automatische korting "Koop X, krijg Y gratis"
   (koop 1 Coat Jenny -> 1 beanie 100% korting, herhalend). Zonder die korting
   staat de beanie gewoon voor €34,99 in de mand. Dit script raakt prijzen niet
   aan -- dat zou in de checkout toch niet standhouden.

   AFSPRAAK: 1 gratis beanie per jas. Twee jassen = twee keer kiezen.

   NA DE ACTIE WEG TE HALEN: dit bestand, pp-cadeau-beanie.css, en de twee
   regels in layout/theme.liquid (zoek op pp-cadeau-beanie).
   ========================================================================== */
(function () {
  'use strict';

  var CFG = {
    // De drie jassen die het cadeau vrijspelen (product-id's, dus alle maten in één keer)
    jasProductIds: [
      9046433988746, // Coat Jenny | New olive   — EAN 8720864595307 t/m ...369
      9046433628298, // Coat Jenny | Hot fudge   — EAN 8720864608601 t/m ...663
      9046433104010  // Coat Jenny | Sand        — EAN 8720864595161 t/m ...222
    ],

    // TIJDELIJK VOOR DE TEST — Coat Jenny staat op nul voorraad, dus hier een
    // jas die wél te bestellen is. HAAL DEZE REGEL WEG VOOR LIVE.
    testJasProductIds: [
      8679374585994, // Coat Calin | Cabernet    | Konges Slojd
      8991914819722  // Coat Calin | Mellow rose | Konges Slojd
    ],

    beanies: [
      { naam: 'Teal blue',     handle: 'beanie-harper-teal-blue-harper-yve',     variantId: 48843821973642, ean: '8720864598001' },
      { naam: 'Violet quartz', handle: 'beanie-harper-violet-quartz-harper-yve', variantId: 48843830165642, ean: '8720864598018' },
      { naam: 'Dark grey',     handle: 'beanie-harper-dark-grey-harper-yve',     variantId: 48843821908106, ean: '8720864597981' }
    ],

    prop: '_cadeau_bij_jas',   // underscore = verborgen in checkout, mail en order
    waarde: '34,99',

    voorwaarden: [
      'Let op: als je de beanie niet gekozen hebt, kunnen we deze achteraf niet ' +
      'alsnog opsturen.',
      'Wil je de jas retourneren? Vergeet dan niet om de gratis beanie mee terug ' +
      'te sturen. Wanneer je de beanie niet retourneert, wordt het aankoopbedrag ' +
      '(&euro;&nbsp;34,99) verrekend met het terug te betalen bedrag.'
    ]
  };

  var TEST_AAN = false;  // LIVE: alleen de echte Coat Jenny's spelen het cadeau vrij

  function jasIds() {
    return TEST_AAN ? CFG.jasProductIds.concat(CFG.testJasProductIds) : CFG.jasProductIds;
  }

  var bezig = false;          // er loopt een ronde; een nieuw verzoek gaat in de wachtrij
  var wachtrij = null;        // zodat een snelle klik tijdens een ronde niet verdwijnt
  var afgewezen = false;      // klant klikte 'liever niet' — deze paginasessie niet opnieuw pushen
  var vorigeJassen = null;    // om te zien of er echt een jas bijkwam
  var jasWacht = false;       // er kwam een jas bij en het cadeau is nog niet gekozen
  var voorraadCache = null;
  var sheet = null;

  /* ---------- winkelmand lezen en schrijven ---------- */

  function haalMand() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function isJas(item) {
    return jasIds().indexOf(item.product_id) !== -1;
  }

  function isCadeau(item) {
    return !!(item.properties && item.properties[CFG.prop]);
  }

  function tel(mand, filter) {
    return (mand.items || []).reduce(function (n, item) {
      return filter(item) ? n + item.quantity : n;
    }, 0);
  }

  function voegToe(variantId) {
    var props = {};
    props[CFG.prop] = 'ja';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('toevoegen mislukt');
      return r.json();
    });
  }

  function zetAantal(lineKey, aantal) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: aantal })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- voorraad van de beanies ---------- */

  function haalVoorraad() {
    if (voorraadCache) return Promise.resolve(voorraadCache);
    return Promise.all(CFG.beanies.map(function (b) {
      return fetch('/products/' + b.handle + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return null;
          var v = null, i;
          for (i = 0; i < p.variants.length; i++) {
            if (p.variants[i].id === b.variantId) { v = p.variants[i]; break; }
          }
          if (!v) v = p.variants[0];
          // Foto 3 is bij alle drie de beanies de packshot (losse muts, gevuld
          // kader). In een klein kaartje laat die de kleur en de strepen veel
          // beter zien dan de modelfoto. Valt terug op de hoofdfoto.
          var foto = (p.images && p.images[2]) || (v.featured_image && v.featured_image.src) || p.featured_image || '';

          return {
            naam: b.naam,
            variantId: v.id,
            beschikbaar: !!v.available,
            foto: foto
          };
        })
        .catch(function () { return null; });
    })).then(function (lijst) {
      voorraadCache = lijst.filter(Boolean);
      return voorraadCache;
    });
  }

  /* ---------- de winkelmand op orde brengen ---------- */

  function sync(magOpenen, forceer) {
    // Loopt er al een ronde, dan die van ons onthouden in plaats van weggooien.
    // Anders mist een klant die snel op 'toevoegen' drukt terwijl de pagina nog
    // aan het opruimen is, zijn keuzescherm.
    if (bezig) {
      wachtrij = {
        magOpenen: (wachtrij && wachtrij.magOpenen) || !!magOpenen,
        forceer: (wachtrij && wachtrij.forceer) || !!forceer
      };
      return Promise.resolve();
    }

    bezig = true;
    return ronde(magOpenen, forceer)
      .catch(function () {})
      .then(function () {
        bezig = false;
        if (wachtrij) {
          var volgende = wachtrij;
          wachtrij = null;
          return sync(volgende.magOpenen, volgende.forceer);
        }
      });
  }

  function ronde(magOpenen, forceer) {
    return haalMand().then(function (mand) {
      var jassen = tel(mand, isJas);
      var cadeaus = tel(mand, isCadeau);

      // Te veel cadeaus (jas verwijderd of aantal verlaagd) — overschot eruit,
      // laatst toegevoegde regel eerst.
      if (cadeaus > jassen) {
        var teveel = cadeaus - jassen;
        var regels = (mand.items || []).filter(isCadeau).reverse();
        var keten = Promise.resolve();

        regels.forEach(function (regel) {
          if (teveel <= 0) return;
          var eraf = Math.min(teveel, regel.quantity);
          teveel -= eraf;
          keten = keten.then(function () {
            return zetAantal(regel.key, regel.quantity - eraf);
          });
        });

        return keten.then(function () { verversDrawer(); });
      }

      // Kwam er werkelijk een jas bij? Zonder die controle opent het scherm ook
      // wanneer de klant iets ánders toevoegt terwijl er een jas zonder cadeau
      // in de mand ligt — bijvoorbeeld een beanie die hij gewoon wil kopen.
      // We houden dat als vlag vast tot het cadeau gekozen is: een tussentijdse
      // opruimronde mag de stijging niet 'opsouperen'.
      if (vorigeJassen !== null && jassen > vorigeJassen) jasWacht = true;
      vorigeJassen = jassen;
      if (jassen <= cadeaus) jasWacht = false;

      // Nog cadeaus te kiezen
      if (jassen > cadeaus && magOpenen && (jasWacht || forceer) && !afgewezen) {
        return open(jassen - cadeaus, jassen);
      }
    });
  }

  /* ---------- keuzescherm ---------- */

  function open(teKiezen, totaalJassen) {
    return haalVoorraad().then(function (beanies) {
      var leverbaar = beanies.filter(function (b) { return b.beschikbaar; });
      if (!leverbaar.length) return;   // alles op: geen scherm, geen loze belofte

      bouw(leverbaar, teKiezen, totaalJassen);
    });
  }

  function bouw(beanies, teKiezen, totaalJassen) {
    // Staat exact dit scherm al open, dan laten staan — anders knippert het
    // wanneer twee rondes vlak na elkaar tot dezelfde conclusie komen.
    if (sheet && sheet.getAttribute('data-stand') === teKiezen + '/' + totaalJassen) return;
    sluit();

    var wrap = document.createElement('div');
    wrap.className = 'ppcb';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', kop);
    wrap.setAttribute('data-stand', teKiezen + '/' + totaalJassen);

    // Met één leverbare kleur valt er niets te kiezen; dan past 'ontvang' beter.
    var teKiezenTekst = beanies.length > 1;
    var kop = teKiezenTekst ? 'Kies je gratis beanie' : 'Ontvang je gratis beanie';
    var titel = totaalJassen > 1
      ? kop + ' (' + (totaalJassen - teKiezen + 1) + ' van ' + totaalJassen + ')'
      : kop;

    // Anders begint de regel eronder ook met 'Ontvang' — dat leest dubbel.
    var sub = teKiezenTekst
      ? 'Ontvang een gratis Harper beanie t.w.v.&nbsp;&euro;' + CFG.waarde + ' bij je jas.'
      : 'Deze Harper beanie t.w.v.&nbsp;&euro;' + CFG.waarde + ' gaat gratis mee met je jas.';

    var kaartjes = beanies.map(function (b) {
      return '<button type="button" class="ppcb__kaart" data-variant="' + b.variantId + '">' +
               '<span class="ppcb__foto">' +
                 (b.foto ? '<img src="' + b.foto + '" alt="Beanie ' + b.naam + '" loading="eager" width="300" height="300">' : '') +
               '</span>' +
               '<span class="ppcb__naam">' + b.naam + '</span>' +
             '</button>';
    }).join('');

    wrap.innerHTML =
      '<div class="ppcb__overlay" data-ppcb-dicht></div>' +
      '<div class="ppcb__sheet">' +
        '<button type="button" class="ppcb__info" data-ppcb-info aria-expanded="false" aria-controls="ppcbVoorwaarden" aria-label="Voorwaarden van de actie">' +
          '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<circle cx="10" cy="10" r="7.5"/><path d="M10 9v4.5"/><path d="M10 6.4v.2"/>' +
          '</svg>' +
        '</button>' +
        '<button type="button" class="ppcb__x" data-ppcb-dicht aria-label="Sluiten">' +
          '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 5l10 10M15 5L5 15"/></svg>' +
        '</button>' +
        '<h2 class="ppcb__titel">' + titel + '</h2>' +
        '<p class="ppcb__sub">' + sub + '</p>' +
        '<div class="ppcb__voorwaarden" id="ppcbVoorwaarden" hidden>' +
          CFG.voorwaarden.map(function (v) { return '<p>' + v + '</p>'; }).join('') +
        '</div>' +
        '<div class="ppcb__kaarten" data-aantal="' + beanies.length + '">' + kaartjes + '</div>' +
        '<button type="button" class="ppcb__nee" data-ppcb-nee>Liever geen beanie</button>' +
        '<div class="ppcb__laden" hidden><span class="ppcb__spin"></span></div>' +
      '</div>';

    document.body.appendChild(wrap);
    document.body.classList.add('ppcb-open');
    sheet = wrap;

    // Eerst de knoppen laten werken, pas daarna de animatie. Andersom zou een
    // hapering in de animatie een scherm opleveren waar niets op reageert.
    wrap.querySelectorAll('[data-ppcb-dicht]').forEach(function (el) {
      el.addEventListener('click', sluit);
    });
    var infoKnop = wrap.querySelector('[data-ppcb-info]');
    var voorwaarden = wrap.querySelector('.ppcb__voorwaarden');
    infoKnop.addEventListener('click', function () {
      var open = voorwaarden.hidden;
      voorwaarden.hidden = !open;
      infoKnop.setAttribute('aria-expanded', open ? 'true' : 'false');
      infoKnop.classList.toggle('is-actief', open);
    });

    wrap.querySelector('[data-ppcb-nee]').addEventListener('click', function () {
      afgewezen = true;
      sluit();
    });
    wrap.querySelectorAll('.ppcb__kaart').forEach(function (knop) {
      knop.addEventListener('click', function () { kies(knop, parseInt(knop.getAttribute('data-variant'), 10)); });
    });

    document.addEventListener('keydown', escSluit);

    var openzetten = function () { wrap.classList.add('is-open'); };
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(openzetten);
    else setTimeout(openzetten, 16);
  }

  function kies(knop, variantId) {
    var laden = sheet && sheet.querySelector('.ppcb__laden');
    if (laden) laden.hidden = false;
    knop.classList.add('is-gekozen');

    voegToe(variantId)
      .then(function () {
        verversDrawer();
        sluit();
        toonDrawer();
        // Meerdere jassen: meteen door naar het volgende cadeau. Er komt dan geen
        // jas bij, dus dit vervolgscherm moet expliciet doorgezet worden.
        return sync(true, true);
      })
      .catch(function () {
        if (laden) laden.hidden = true;
        knop.classList.remove('is-gekozen');
        voorraadCache = null;   // wellicht net uitverkocht — opnieuw ophalen
        toon('Dat lukte net niet. Probeer een andere kleur.');
      });
  }

  function toon(tekst) {
    if (!sheet) return;
    var bestaand = sheet.querySelector('.ppcb__fout');
    if (bestaand) { bestaand.textContent = tekst; return; }
    var p = document.createElement('p');
    p.className = 'ppcb__fout';
    p.textContent = tekst;
    sheet.querySelector('.ppcb__sheet').appendChild(p);
  }

  function escSluit(e) { if (e.key === 'Escape') sluit(); }

  function sluit() {
    document.removeEventListener('keydown', escSluit);
    document.body.classList.remove('ppcb-open');
    if (!sheet) return;
    var oud = sheet;
    sheet = null;
    oud.classList.remove('is-open');
    setTimeout(function () { if (oud.parentNode) oud.parentNode.removeChild(oud); }, 260);
  }

  /* ---------- winkelmand-lade opnieuw laten tekenen ----------
     Het thema doet dit intern via een privémethode, dus we bootsen het na:
     de sectie api-cart-items ophalen en de holders in de lade vervangen. */

  function verversDrawer() {
    document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));

    fetch('/cart?section_id=api-cart-items', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doos = document.createElement('div');
        doos.innerHTML = html;

        vervang(doos, '[data-api-line-items]', '[data-items-holder]');
        vervang(doos, '[data-api-upsell-items]', '[data-pair-products-holder]');
        vervang(doos, '[data-api-cart-price]', '[data-cart-price-holder]');

        // Kop en checkoutknop staan buiten die sectie: die zelf bijwerken
        return haalMand().then(function (mand) {
          var holder = document.querySelector('[data-items-holder]');
          if (holder) holder.classList.toggle('hidden', mand.item_count === 0);

          document.querySelectorAll('[data-cart-items-qty]').forEach(function (el) {
            el.classList.toggle('hidden', mand.item_count === 0);
            el.textContent = mand.item_count === 1 ? '1 artikel' : mand.item_count + ' artikelen';
          });

          document.querySelectorAll('[data-cart-total-price]').forEach(function (el) {
            el.textContent = euro(mand.total_price);
          });

          document.dispatchEvent(new CustomEvent('theme:cart:loaded', { bubbles: true }));
        });
      })
      .catch(function () {});
  }

  function euro(centen) {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(centen / 100);
    } catch (e) {
      return '\u20ac ' + (centen / 100).toFixed(2).replace('.', ',');
    }
  }

  // Na het kiezen moet de klant zijn cadeau in de mand zien landen. Staat de
  // lade dicht (het thema sluit hem soms zodra er een pop-up overheen komt),
  // dan openen we hem via de gewone toggle -- dan speelt de animatie ook.
  function toonDrawer() {
    var lade = document.querySelector('[data-cart-drawer]');
    if (!lade) return;   // winkelmandlade staat uit; dan is er niets te openen

    var staatOpen = document.body.classList.contains('js-drawer-open-cart') ||
                    lade.classList.contains('is-open');
    if (staatOpen) return;

    var toggles = [].slice.call(document.querySelectorAll('[data-cart-drawer-toggle]'));
    // De toggle binnen de lade is de sluitknop; pak er een van buiten (de header)
    var toggle = toggles.filter(function (t) { return !t.closest('[data-cart-drawer]'); })[0];
    if (toggle) toggle.click();
  }

  function vervang(bron, vanSel, naarSel) {
    var nieuw = bron.querySelector(vanSel);
    var doel = document.querySelector(naarSel);
    if (nieuw && doel) doel.innerHTML = nieuw.innerHTML;
  }

  /* ---------- aanhaken ---------- */

  // Motor: de thema-eigen events (die overleven Shopify's web-pixel wél)
  ['theme:cart:added', 'theme:cart:update', 'theme:cart:loaded'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(function () { sync(evt === 'theme:cart:added'); }, 250); });
  });

  // Vangnet: meekijken met cart-verkeer, want de events zijn niet overal even
  // betrouwbaar (quickview, collectiepagina). Zelfde patroon als de mand-teller.
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function wikkelFetch() {
    var huidig = window.fetch;
    if (!huidig || huidig._ppCadeau) return;
    var basis = huidig;
    var nieuw = function () {
      var p = basis.apply(this, arguments);
      try {
        var a0 = arguments[0];
        var url = (a0 && a0.url) ? a0.url : a0;
        if (CART_RE.test(String(url))) {
          var isAdd = /\/cart\/add/.test(String(url));
          p.then(function () { setTimeout(function () { sync(isAdd); }, 300); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
    nieuw._ppCadeau = true;
    window.fetch = nieuw;
  }

  function wikkelXhr() {
    var proto = XMLHttpRequest.prototype;
    if (proto.open._ppCadeau) return;
    var basis = proto.open;
    var nieuw = function (method, url) {
      try {
        if (CART_RE.test(String(url))) {
          var isAdd = /\/cart\/add/.test(String(url));
          this.addEventListener('load', function () { setTimeout(function () { sync(isAdd); }, 300); });
        }
      } catch (e) {}
      return basis.apply(this, arguments);
    };
    nieuw._ppCadeau = true;
    proto.open = nieuw;
  }

  wikkelFetch(); wikkelXhr();
  window.addEventListener('load', function () {
    wikkelFetch(); wikkelXhr();
    setTimeout(function () { wikkelFetch(); wikkelXhr(); }, 1500);
  });

  // Bij binnenkomst alleen opruimen, niet ongevraagd een scherm openen
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(false); });
  } else {
    sync(false);
  }

  window.__ppCadeauBeanie = { sync: sync, open: open, cfg: CFG, versie: 'v1' };
})();
